export default "__VITE_ASSET__ZZGV3all__"